import { Controller } from "@hotwired/stimulus"
import noUiSlider from "nouislider"

export default class extends Controller {
  static targets = ["slider", "lengthInput", "confirmation", "toggle", "aiForm", "note"]
  static values = {
    updateUrl: String,
    enabled: Boolean,
  }

  connect() {
    this._initSlider()
  }

  _initSlider() {
    // Initialize the slider
    noUiSlider.create(this.sliderTarget, {
      start: parseInt(this.lengthInputTarget.value) || 20,
      connect: "lower",
      snap: true,
      range: {
        min: 20,
        "25%": 50,
        "50%": 100,
        "75%": 150,
        max: 200,
      },
      pips: {
        mode: "steps",
        density: 100,
      },
    })

    // Update the hidden input when the slider changes
    this.sliderTarget.noUiSlider.on("update", (values, handle) => {
      this.lengthInputTarget.value = Math.floor(values[handle])
    })

    if (this.sliderTarget.dataset.disabled === "disabled") {
      this.sliderTarget.noUiSlider.disable()
    } else {
      this.sliderTarget.noUiSlider.enable()
    }
  }

  toggle(event) {
    event.preventDefault()
    const isEnabled = event.target.checked
    const notEditable = event.target.disabled === true

    if (notEditable) {
      event.preventDefault()
      event.target.checked = !isEnabled
      return
    }

    if (isEnabled) {
      // Currently disabled, turning on
      this._updateAiAssistantState(true)
      this.confirmationTarget.classList.add("d-none")

      this.dispatch("enabled")

      App.analytics.posthog_capture("AI assistant: toggled on", {
        campaign_id: this.element.dataset.campaignId,
      })
    } else {
      // Currently enabled, show confirmation before turning off
      this.confirmationTarget.classList.remove("d-none")
      this.toggleTarget.checked = true
    }
  }

  _updateAiAssistantState(enabled) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.updateUrlValue, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({
        ai_assistant_enabled: enabled,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          console.error("Error updating AI assistant state:", data.error)
          this.toggleTarget.checked = this.enabledValue
        } else {
          this.enabledValue = enabled

          if (enabled) {
            this.aiFormTarget.classList.remove("d-none")
            this.noteTarget.classList.remove("d-none")
          } else {
            this.aiFormTarget.classList.add("d-none")
            this.noteTarget.classList.add("d-none")
          }
        }
      })
  }

  confirmDisable(event) {
    event.preventDefault()
    this.confirmationTarget.classList.add("d-none")
    this._updateAiAssistantState(false)
    this.toggleTarget.checked = false

    this.dispatch("disabled")

    App.analytics.posthog_capture("AI assistant: toggled off", {
      campaign_id: this.element.dataset.campaignId,
    })
  }

  cancelDisable(event) {
    event.preventDefault()
    this.confirmationTarget.classList.add("d-none")
    this.toggleTarget.checked = true
  }
}
